import React, { useState } from 'react';

export default function LandingPage({ onLogin }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerifyApiKey = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(
        `http://192.168.52.172:8088/ApiDocAndSandbox/api/Auth/GetAuthUser?key=${apiKey}`,
        { method: 'GET', redirect: 'follow' }
      );
      const result = await response.json();
      if (result.responseCode === '00') {
        onLogin(apiKey);
      } else {
        setError(result.responseMessage || 'Invalid Access key.');
      }
    } catch (err) {
      setError('Failed to verify Access key. Please try again.');
      console.error('Verify error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      fullname: fullName,
      emailAddress: email,
      phoneNumber: phone,
    };

    try {
      const response = await fetch(
        'http://192.168.52.172:8088/ApiDocAndSandbox/api/Auth/AuthUser',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          redirect: 'follow',
        }
      );
      const result = await response.json();
      if (result.responseCode === '00') {
        setApiKey(result.responseData);
        setIsRegistering(false);
        onLogin(result.responseData); // Auto-login after registration
      } else {
        setError(result.responseMessage || 'Registration failed.');
      }
    } catch (err) {
      setError('Failed to register. Please try again.');
      console.error('Register error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-semibold text-center text-[#fdb814] mb-6">
          Welcome to Providus API Sandbox
        </h1>
        {isRegistering ? (
          <form onSubmit={handleRegister} className="space-y-4">
            <div>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Full Name"
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#fdb814]"
                required
              />
            </div>
            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#fdb814]"
                required
              />
            </div>
            <div>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone Number"
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#fdb814]"
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-[#fdb814] text-white rounded hover:bg-[#0A0A0A] disabled:bg-orange-300"
            >
              {loading ? 'Registering...' : 'Register'}
            </button>
            <p className="text-center text-sm">
              Already have an Access key?{' '}
              <button
                type="button"
                className="text-[#fdb814] hover:underline"
                onClick={() => setIsRegistering(false)}
              >
                Enter it here
              </button>
            </p>
          </form>
        ) : (
          <form onSubmit={handleVerifyApiKey} className="space-y-4">
            <div>
              <input
                type="text"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter your Access key"
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#fdb814]"
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-[#fdb814] text-white rounded hover:bg-[#0A0A0A] disabled:bg-orange-300"
            >
              {loading ? 'Verifying...' : 'Access Sandbox'}
            </button>
            <p className="text-center text-sm">
              Don’t have an Access key?{' '}
              <button
                type="button"
                className="text-[#fdb814] hover:underline"
                onClick={() => setIsRegistering(true)}
              >
                Get your Access key here
              </button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}